<template>
    <div class="CommPosFixed">
        <div class="CommPosTop">
            <div class="CommPosTop-left">个人中心</div>
            <div class="CommPosTop-right">
                <el-button v-throttle v-if="Only" type="primary" size="small" @click="ToggSystem">申请其他类型项目</el-button>
                <el-button v-throttle v-if="Only" type="primary" size="small" @click="Only=false">修改信息</el-button>
                <el-button v-throttle v-if="Only" type="primary" size="small" @click="ToggPass">修改密码</el-button>
                <el-button v-throttle size="small" @click="Built">返回</el-button>
            </div>
        </div>
        <div class="CommHead">
            <div class="CommNav">
                <span class="Act">基本信息</span>
            </div>
            <div class="CommCont">
                <div class="CommCont-title">基本信息</div>
                <div class="CommCont-list">
                    <div class="CommCont-item">
                        <div class="CommCont-Dis">
                            <span>账号：</span>
                            <el-input class="CommContVal" size="medium" placeholder="请输入账号" v-model="NewData.username" disabled></el-input>
                        </div>
                    </div>
                    <div class="CommCont-item">
                        <div class="CommCont-Dis">
                            <span>姓名：</span>
                            <el-input class="CommContVal" size="medium" placeholder="请输入名称" v-model="NewData.name" :readonly="Only"></el-input>
                        </div>
                    </div>
                    <div class="CommCont-item">
                        <div class="CommCont-Dis">
                            <span>手机号：</span>
                            <el-input class="CommContVal" size="medium" placeholder="请输入手机号" v-model="NewData.phone" :readonly="Only"></el-input>
                        </div>
                    </div>
                    <div class="CommCont-item">
                        <div class="CommCont-Dis">
                            <span>邮箱：</span>
                            <el-input class="CommContVal" size="medium" placeholder="请输入邮箱" v-model="NewData.email" :readonly="Only"></el-input>
                        </div>
                    </div>
                    <div class="CommCont-item">
                        <div class="CommCont-Dis">
                            <span>工作单位：</span>
                            <el-input class="CommContVal" size="medium" placeholder="请输入工作单位" v-model="NewData.work_unit" :readonly="Only"></el-input>
                        </div>
                    </div>
                    <div class="CommCont-item">
                        <div class="CommCont-Dis">
                            <span>科室：</span>
                            <el-input class="CommContVal" size="medium" placeholder="请输入科室" v-model="NewData.department" :readonly="Only"></el-input>
                        </div>
                    </div>
                    <div class="CommCont-item">
                        <div class="CommCont-Dis">
                            <span>职称：</span>
                            <el-input class="CommContVal" size="medium" placeholder="请输入职称" v-model="NewData.title" :readonly="Only"></el-input>
                        </div>
                    </div>
                    <div class="CommCont-item">
                        <div class="CommCont-Dis">
                            <span>职务：</span>
                            <el-input class="CommContVal" size="medium" placeholder="请输入职务" v-model="NewData.position" :readonly="Only"></el-input>
                        </div>
                    </div>
                    <div class="CommCont-item" v-if="Data.is_expert">
                        <div class="CommCont-Dis">
                            <span>专业领域：</span>
                            <el-select class="CommContVal" size="medium" v-model="NewData.field_ids" placeholder="请选择专业领域" multiple  :disabled="Only">
                                <el-option v-for="item in LingYuList" :key="item.id" :label="item.name" :value="item.id"></el-option>
                            </el-select>
                        </div>
                    </div>
                    <div class="CommCont-item">
                        <div class="CommCont-Dis">
                            <span>简历：</span>
                            <el-upload v-if="!NewData.jianli_url" action="none" :show-file-list="false" :http-request="(res) => UploadFlie(res)" :disabled="Only">
                                <el-button v-throttle class="BgColor" size="small" type="info">上传</el-button>
                                <span> 文件上传限制100M以内</span>
                            </el-upload>
                            <div v-else>
                                <span>文件</span>
                                <el-tooltip effect="dark" content="查看简历" placement="top-start">
                                    <i class="NavIcon el-icon-view" @click="LockUrl(NewData.jianli_url)"></i>
                                </el-tooltip>
                                <el-tooltip effect="dark" content="删除文件" placement="top-start">
                                    <i v-if="!Only" class="NavIcon el-icon-delete" @click="NewData.jianli_url = ''"></i>
                                </el-tooltip>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <div class="CommHead" v-if="Data.is_expert">
            <div class="CommNav">
                <span class="Act">银行信息</span>
            </div>
            <div class="CommCont">
                <div class="CommCont-title">银行信息</div>
                <div class="CommCont-list">
                    <div class="CommCont-item">
                        <div class="CommCont-Dis">
                            <span>账号：</span>
                            <el-input class="CommContVal" size="medium" placeholder="请输入账号" v-model="NewData.bank_card_number" :readonly="Only"></el-input>
                        </div>
                    </div>
                    <div class="CommCont-item">
                        <div class="CommCont-Dis">
                            <span>户名：</span>
                            <el-input class="CommContVal" size="medium" placeholder="请输入户名" v-model="NewData.bank_user_name" :readonly="Only"></el-input>
                        </div>
                    </div>
                    <div class="CommCont-item">
                        <div class="CommCont-Dis">
                            <span>开户行：</span>
                            <el-input class="CommContVal" size="medium" placeholder="请输入开户行" v-model="NewData.bank_name" :readonly="Only"></el-input>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <div class="EdiBtn" v-if="!Only">
            <el-button v-throttle size="small" @click="CloseInfo">取消</el-button>
            <el-button v-throttle class="BgColor" size="small" type="primary" @click="SetInfo">保存信息</el-button>
        </div>
        <el-dialog title="修改密码" :visible.sync="PassData.PassBlon" width="20%" class="BorderRadius" :modal-append-to-body="false" :close-on-press-escape="false" :close-on-click-modal="false">
            <div class="DigItem">
                <div class="DigItemTit">旧密码：</div>
                <el-input class="Wid" size="medium" placeholder="请输入新密码" v-model="PassData.yuanpass" show-password></el-input>
            </div>
            <div class="DigItem">
                <div class="DigItemTit">新密码：</div>
                <el-input class="Wid" size="medium" placeholder="请输入新密码" v-model="PassData.newword" show-password></el-input>
            </div>
            <div class="DigItem">
                <div class="DigItemTit">确认密码：</div>
                <el-input class="Wid" size="medium" placeholder="请输入确认密码" v-model="PassData.sucpass" show-password></el-input>
            </div>
            <div slot="footer">
                <el-button v-throttle size="small" @click="$Tools.ResetData(PassData);">取消</el-button>
                <el-button v-throttle class="BgColor" size="small" type="primary" @click="SetPass">确定</el-button>
            </div>
        </el-dialog>
        <el-dialog title="系统选择" :visible.sync="SystemData.SysBlon" width="40%" class="BorderRadius" :modal-append-to-body="false">
            <div class="DigItem">
                <div class="DigItemTit MarBom">系统：</div>
                <!-- <el-checkbox-group size="medium" v-model="SystemData.SysId" @change="ChangeSys">
                    <el-checkbox class="MarBom" v-for="item in SystemList" :label="item.id" :key="item.id">{{item.system_name}}</el-checkbox>
                </el-checkbox-group> -->
                <el-cascader class="Wid" size="medium" v-model="SystemData.SysId" :options="SystemList" :props="{multiple: true,value:'id',label:'system_name',children:'child'}" clearable></el-cascader>
            </div>
            <div slot="footer">
                <el-button v-throttle size="small" @click="$Tools.ResetData(SystemData)">取消</el-button>
                <el-button v-throttle class="BgColor" size="small" type="primary" @click="SucSys">确定</el-button>
            </div>
        </el-dialog>
    </div>
</template>

<script>
export default {
    data() {
        return {
            Data:"",
            LingYuList:'',
            NewData:{
                username:"",
                name:"",
                phone:"",
                email:"",
                bank_card_number:"",
                bank_name:"",
                bank_user_name:"",
                work_unit:"",
                department:"",
                position:"",
                title:"",
                field_ids:"",
                jianli_url:"",
            },
            PassData:{
                PassBlon:false,
                yuanpass:"",
                newword:"",
                sucpass:"",
            },
            SystemList:[],
            SystemData:{
                SysBlon:false,
                SysId:[],
            },
            Only:true,
        }
    },
    mounted() {
        this.GetData();
        this.GetLingYuList();
    },
    methods: {
        GetData() {
            this.$get('/api/auth/userInfo')
            .then((res) => {
                if (res) {
                    this.Data = res.data;
                    this.NewData.username = this.Data.username;
                    this.NewData.name = this.Data.name;
                    this.NewData.phone = this.Data.phone;
                    this.NewData.email = this.Data.email;
                    this.NewData.bank_card_number = this.Data.bank_card_number;
                    this.NewData.bank_name = this.Data.bank_name;
                    this.NewData.bank_user_name = this.Data.bank_user_name;
                    this.NewData.work_unit = this.Data.work_unit;
                    this.NewData.department = this.Data.department;
                    this.NewData.position = this.Data.position;
                    this.NewData.title = this.Data.title;
                    this.NewData.field_ids = this.Data.field_ids;
                    this.NewData.jianli_url = this.Data.jianli_url;
                }
            })
        },
        GetLingYuList(){
            this.$get('/api/auth/expertfield').then(res=>{
                if(res){
                    this.LingYuList = res.data;
                }
            })
        },
        SetPass(){
            this.$post('/api/auth/userPass',{
                password: this.PassData.yuanpass,
                passwords:this.PassData.newword,
                passwordss:this.PassData.sucpass,
            }).then(res=>{
                if(res){
                    this.$message.success(res.msg);
                    this.$Tools.ResetData(this.PassData);
                    if(localStorage.getItem('g') ==1){
                        this.$router.push('/AdminLogin');
                    }else{
                        this.$router.push('/login');
                    }
                }
            })
        },
        CloseInfo(){
            this.GetData();
            this.Only = true;
        },
        SetInfo(){
            this.$post('/api/auth/userEdit',this.NewData).then(res=>{
                if(res){
                    this.$message.success(res.msg);
                    this.GetData();
                    this.Only = true;
                }
            })
        },
        ToggPass(){
            this.$Tools.ResetData(this.PassData);
            this.PassData.PassBlon = true;
        },
        ToggSystem(){
            this.$Tools.ResetData(this.SystemData);
            // var SysData = JSON.parse(this.$Tools.localData("SystemMenu"));
            // var smallData = JSON.parse(sessionStorage.getItem("Nav"));
            // this.SystemList = SysData.filter(item => {
            //     return !smallData.some(smallItem => smallItem.id === item.id);
            // });
            this.$get('/api/auth/getAlls').then(res=>{
                if(res){
                    this.SystemList = res.data;
                    this.SystemData.SysBlon = true;
                }
            })
            
        },
        ChangeSys(i){
            this.SystemData.SysId = i;
        },
        SucSys(){
            this.$post('/api/auth/ApplyAdd',{
                system_id:this.SystemData.SysId,
            }).then(res=>{
                if(res){
                    this.$message.success(res.msg);
                    this.SystemData.SysBlon = false;
                }
            })
        },
        UploadFlie(row){
            var file = row.file;
            const loading = this.$loading({lock: true,text: 'Loading',spinner: 'el-icon-loading',background: 'rgba(0, 0, 0, 0.7)'});
            const MAX_SIZE = 100 * 1024 * 1024;
            const fileSize = file.size;
            if (fileSize > MAX_SIZE) {
                this.$message.error(`文件大小超出限制！最大支持100M，当前文件大小：${(fileSize / 1024 / 1024).toFixed(2)}M`);
                return;
            }
            try {
                var fd = new FormData()
                fd.append('file',file);
                this.$post("/common/upload/image",fd,{
                    headers: {
                        'Content-Type': 'application/x-www-form-urlencoded',
                    }
                }).then((res)=>{
                    loading.close();
                    this.NewData.jianli_url = res.data.url;
                })
            } catch (error) {
                loading.close();
            }
        },
        LockUrl(url){
            window.open(this.$Tools.ServeUrl()+url)
        },
        Built() {
            this.$router.go(-1)
        },
    }
}
</script>

<style scoped>
.CommPosTop {
    display: flex;
    align-items: center;
    justify-content: space-between;
    height: 46px;
    padding: 0 24px 0 0;
    color: #212b36;
    border-bottom: 1px solid #ddd;
}

.CommPosTop-left {
    border-left: 4px solid #409EFF;
    padding-left: 24px;
    font-size: 22px;
}

.CommHead {
    display: flex;
    align-items: flex-start;
    padding: 20px;
    overflow-y: auto;
}

.CommNav {
    width: 152px;
    color: #545861;
    font-size: 12px;
}

.CommNav span {
    display: block;
    border-radius: 3px 0 0 3px;
    padding: 8px 24px;
    text-align: right;
    word-break: break-all;
    cursor: pointer;
}

.CommNav span.Act {
    background-color: #eff3fc;
    color: #191c21;
}

.CommCont {
    margin: 0 20px;
    flex: 1;
}

.CommCont-title {
    padding: 10px;
    width: 100%;
    line-height: 16px;
    padding-left: 8px;
    font-size: 16px;
    border-left: 4px solid #409EFF;
    background: #d7ebff;
}

.CommCont-list {
    margin-top: 20px;
    display: flex;
    align-items: flex-start;
    flex-wrap: wrap;
}

.CommCont-list.Block {
    display: block;
}

.CommCont-item {
    width: 50%;
    padding-bottom: 20px;
    position: relative;
}

.CommCont-item.Wid {
    width: 100%;
}

.CommCont-Dis {
    display: flex;
    align-items: center;
}
.CommCont-item span {
    width: 120px;
    padding-left: 5px;
    text-align: right;
}
.CommCont-item .CommContVal {
    width: 400px;
}
.EdiBtn{
    padding-top: 10px;
    text-align: center;
}
</style>
